import { Box } from '@material-ui/core'
import React from 'react'
import Loader from '../../Loader/CalendarLoader/Loader'

const SearchLoader = () => (
  <Box
    alignItems={'center'}
    justifyContent={'center'}
    style={{ minHeight: '100px', position: 'relative' }}
  >
    <Loader />
  </Box>
)

export default SearchLoader
